import type { FC } from 'react'
import { scoreColor } from '../domain/Bet.domain'

interface Props {
  value: number
  onChange: (score: number) => void
}

export const ScoreSelector: FC<Props> = ({ value, onChange }) => (
  <div style={{ display: 'flex', gap: 2 }}>
    {([1, 2, 3, 4, 5] as const).map((n) => (
      <button
        key={n}
        onClick={() => onChange(n)}
        style={{
          width: 22,
          height: 22,
          borderRadius: 4,
          border: '1px solid #e5e7eb',
          fontSize: 11,
          fontWeight: 600,
          cursor: 'pointer',
          background: value === n ? scoreColor(n) : '#fff',
          color: value === n ? '#fff' : '#9ca3af',
        }}
      >
        {n}
      </button>
    ))}
  </div>
)
